<div class="d-flex justify-content-between text-nowrap">
    <label class="d-inline-block mr-2">{{label}}</label>
    <input class="form-control"  style="max-width: 100px" [value]="subscription.value ? subscription.value : '-'"  (change)="change($event)">
</div>